const initialState = {
  input: { email: "", password: "" },
  error: {
    email: false,
    password: false,
  },
  errorMessage: {
    email: "",
    password: "",
  },
};

function loginForm(state = initialState, action) {
  switch (action.type) {
    case "SET_FORM_INPUT":
      return {
        ...state,
        input: { email: action.data.email, password: action.data.password },
      };
    case "OPEN_FORM_EMAIL_ERROR":
      return {
        ...state,
        error: { ...state.error, email: action.data.form1 },
        errorMessage: { ...state.errorMessage, email: action.data.form1Message },
      };
    case "OPEN_FORM_PASSWORD_ERROR":
      return {
        ...state,
        error: { ...state.error, password: action.data.form2 },
        errorMessage: { ...state.errorMessage, password: action.data.form2Message },
      };
    case "RESET_APP":
      return initialState;
    default:
      return state;
  }
}

export default loginForm;
